<form *ngIf="clientFormGroup" [formGroup]="clientFormGroup">
    <p-card class="p-3" header="Datos generales">
        <div class="grid">
            <div class="col input-field">
                <label for="thirdPartySourceId">Tipo *</label>
                <p-dropdown [options]="clientTypes" formControlName="clientType" optionValue="value"
                    appendTo="body" optionLabel="name" showClear 
                    placeholder="Seleccione tipo" d-form-field-error />
            </div>
             <div class="col input-field">
                <label for="name">Perfil</label>
                <p-dropdown [options]="clientSubtypes" formControlName="clientSubTypeId" optionValue="id"
                    [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione el perfil"
                    d-form-field-error showClear />
            </div>
            <div class="col input-field">
                <label for="name">Nombre *</label>
                <input pInputText formControlName="name" d-form-field-error />
            </div>
            <div class="col input-field">
                <label for="vatNumber">CIF</label>
                <input pInputText formControlName="vatNumber" d-form-field-error />
            </div>
            <div class="col input-field">
                <label for="thirdPartySourceId">Origen</label>
                <p-dropdown [options]="thirdPartySources" formControlName="thirdPartySourceId" optionValue="id"
                    [filter]="true" appendTo="body" filterBy="name" optionLabel="name" showClear 
                    placeholder="Seleccione origen del cliente" d-form-field-error />
            </div>
        </div>
        <div class="grid pt-2">            
            <div class="col-2 input-field">
                <label for="active" class="mr-1">Activo</label>
                <div class="flex h-full">
                    <p-inputSwitch formControlName="active" d-form-field-error></p-inputSwitch>
                </div>
            </div>
            <div class="col input-field ">
                <label for="legalName">Razón social</label>
                <input pInputText formControlName="legalName" type="text" d-form-field-error />
            </div>
            <div class="col input-field ">
                <label for="email">Email</label>
                <input pInputText formControlName="email" type="text" d-form-field-error />
            </div>            
           
        </div>
        <div class="grid pt-2">
            <div class="col input-field ">
                <div class="flex gap-1 align-items-center mb-1">
                    <p-radioButton name="priorityPhone" value="1" formControlName="priorityPhone" inputId="answer-1" />
                    <label for="phone1">Teléfono</label>
                </div>
                <input pInputText formControlName="phone1" type="text" d-form-field-error />
            </div>
            <div class="col input-field ">
                <div class="flex gap-1 align-items-center mb-1">
                    <p-radioButton name="priorityPhone" value="2" formControlName="priorityPhone" inputId="answer-2" />
                    <label for="phone2">Teléfono 2</label>
                </div>
                <input pInputText formControlName="phone2" type="text" d-form-field-error />
            </div>
            <div class="col input-field ">
                <div class="flex gap-1 align-items-center mb-1">
                    <p-radioButton name="priorityPhone" value="3" formControlName="priorityPhone" inputId="answer-3" />
                    <label for="phone3">Teléfono 3</label>
                </div>
                <input pInputText formControlName="phone3" type="text" d-form-field-error />
            </div>
        </div>
        <div class="grid pt-2">
            <div class="col input-field ">
                <label for="phone1Description">Notas teléfono</label>
                <input pInputText formControlName="phone1Description" type="text" d-form-field-error />
            </div>
            <div class="col input-field ">
                <label for="phone2Description">Notas teléfono 2</label>
                <input pInputText formControlName="phone2Description" type="text" d-form-field-error />
            </div>
            <div class="col input-field ">
                <label for="phone3Description">Notas teléfono 3</label>
                <input pInputText formControlName="phone3Description" type="text" d-form-field-error />
            </div>
        </div>
        <div class="grid pt-2" formGroupName="address">
            <div class="col input-field col-3">
                <label for="name">Dirección *</label>
                <input pInputText formControlName="addressLine1" type="text" d-form-field-error />
            </div>
            <div class="col input-field col-2">
                <label for="name">Código postal</label>
                <input pInputText formControlName="zipCode" type="text" d-form-field-error />
            </div>
            <div class="col input-field col-3">
                <label for="name">Ciudad</label>
                <input pInputText formControlName="city" type="text" d-form-field-error />
            </div>
            <div class="col input-field col-2">
                <label for="name">Provincia</label>
                <p-dropdown [options]="countriesRegions" formControlName="countryRegionId" optionValue="id"
                    [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione provincia"
                    d-form-field-error showClear (onChange)="loadCountries()" />
            </div>
            <div class="col input-field col-2">
                <label for="name">País</label>
                <p-dropdown [options]="countries" formControlName="countryCode" optionValue="code" [filter]="true"
                    appendTo="body" filterBy="name" optionLabel="name" placeholder="Seleccione país"
                    d-form-field-error />
            </div>
        </div>
        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete && client.id" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </p-card>
    <p-tabView>
        <p-tabPanel header="Datos bancarios">
            <div class="formgrid grid pt-2" formGroupName="bankAccount">
                <div class="col input-field ">
                    <label for="name">Banco</label>
                    <p-dropdown formControlName="bankId" [options]="banks" optionLabel="name" optionValue="id"
                        appendTo="body" [filter]="true" filterBy="name" placeholder="Selecciona un banco"
                        d-form-field-error />
                </div>
                <div class="col input-field ">
                    <label for="name">Nº Cuenta</label>
                    <input pInputText formControlName="accountNumber" type="text" d-form-field-error />
                </div>
                <div class="col input-field ">
                    <label for="name">Swift</label>
                    <input pInputText formControlName="swift" type="text" d-form-field-error />
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Pólizas" [disabled]="!client.id">
            <div class="flex justify-content-end mb-2">
                <p-button *ngIf="allowWrite" label="Añadir póliza" icon="pi pi-plus" (click)="editClientPolicy(null)" />
            </div>

            <p-table #grid [value]="clientPolicies" [loading]="loadingClientPolicies" [paginator]="true" [rows]="5"
                [totalRecords]="totalClientPoliciesRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[5,10,20]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="policyNumber">Número de póliza <p-sortIcon
                                field="policyNumber"></p-sortIcon></th>
                        <th pSortableColumn="insuranceCompany.name">Compañía aseguradora <p-sortIcon
                                field="insuranceCompany.name"></p-sortIcon></th>
                        <th pSortableColumn="description">Descripción <p-sortIcon field="description"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-clientPolicy let-columns="columns">
                    <tr (dblclick)="editClientPolicy(clientPolicy)">
                        <td>{{clientPolicy.policyNumber}}</td>
                        <td>{{clientPolicy.insuranceCompany?.name}}</td>
                        <td>{{clientPolicy.description}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Expedientes" [disabled]="!client.id">
            <p-table styleClass="mt-4" #grid [value]="cases" [lazy]="true" (onLazyLoad)="loadCases($event)" [loading]="loading"
                [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width: 50px;">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="reference">Referencia <p-sortIcon field="reference"></p-sortIcon></th>            
                        <th pSortableColumn="caseNumber">Id Expediente <p-sortIcon field="caseNumber"></p-sortIcon></th>
                        <th pSortableColumn="case.company.name">Compañia <p-sortIcon field="case.company.name"></p-sortIcon></th>
                        <th pSortableColumn="case.contract.code">Contrato <p-sortIcon field="case.contract.code"></p-sortIcon></th>
                        <th pSortableColumn="caseDate">Fecha <p-sortIcon field="caseDate"></p-sortIcon></th>
                        <th pSortableColumn="caseType.name">Tipo <p-sortIcon field="caseType.name"></p-sortIcon></th>
                        <th pSortableColumn="client.name">Asegurado <p-sortIcon field="client.name"></p-sortIcon></th>
                        <th pSortableColumn="address.addressLine1">Dirección <p-sortIcon field="address.addressLine1"></p-sortIcon>
                        </th>
                        <th pSortableColumn="processor.name">Tramitador <p-sortIcon field="processor.name"></p-sortIcon></th>
                        <th>Días abierto</th>
                        <th pSortableColumn="caseState.name">Estado <p-sortIcon field="caseState.name"></p-sortIcon></th>
                        <th pSortableColumn="revisionDate">Fecha revisión <p-sortIcon field="revisionDate"></p-sortIcon></th>
                        <th pSortableColumn="companyWorkInProgress">Obra en curso <p-sortIcon field="companyWorkInProgress"></p-sortIcon></th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-case let-columns="columns">
                    <tr [pSelectableRow]="case">
                        <td>
                            <p-tableCheckbox [value]="case"></p-tableCheckbox>
                        </td>
                        <td>{{case.reference}}</td>
                        <td>{{case.caseNumber}}</td>
                        <td>
                            <span *ngIf="case.companyId != null">{{case.company?.name}}</span>    
                            <span class="text-danger" *ngIf="case.companyId == null">Sin compañía</span>                    
                        </td>
                        <td>
                            <span *ngIf="case.contractId != null">{{case.contract?.code}}</span>    
                            <span class="text-danger" *ngIf="case.contractId == null">Sin contrato</span>                    
                        </td>
                        <td>{{case.caseDate | date: 'dd/MM/yyyy'}}</td>
                        <td>{{case.caseType?.name}}</td>
                        <td>{{case.client?.name}}</td>
                        <td>{{case.address?.fullAddress}}</td>
                        <td>{{case.processor?.name}}</td>
                        <td>{{dateUtilsService.getTimeAgo(case.caseDate)}}</td>
                        <td>
                            <span class="p-tag" [style.backgroundColor]="case.caseState?.backgroundColor" [style.foregroundColor]="case.caseState?.foregroundColor">
                                <span class="p-tag-label">{{case.caseState?.name}}</span>
                            </span>
                        </td>
                        <td>                
                            <span [ngClass]="getRevisionDateClass(case.revisionDate)">                    
                                {{ case.revisionDate | date: 'dd/MM/yyyy' }}
                            </span>                
                        </td>
                        <td>{{case.companyWorkInProgress | currency:'EUR':'symbol':'1.2-2' }}</td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <a *ngIf="allowWrite" routerLink="/cases/{{case.id}}" target="_blank" class="p-button p-button-rounded"><i class="pi pi-pencil"></i></a>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </p-tabView>
</form>
<p-confirmDialog></p-confirmDialog>